import { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import ModalContext from "components/contexts/ModalContext";
import ConsentDetailModal from "./ConsentDetailModal";
import client from "api/WookAxios";
import { naver, kakao, google, authorize } from "auth/DeprecatedOAuth";
import naverOAuth from "images/naverLogoButton.png";
import kakaoOAuth from "images/kakao_oauth_large.png";
import googleOAuth from "images/google_oauth.svg";
import { AiOutlineClose } from "react-icons/ai";
import { Navigate, useNavigate } from "react-router-dom";
import useAuthenticate, { useAuth } from "auth/useAuth";
import StyledButton from "components/common/Button";
import { AiOutlineRight } from 'react-icons/ai';
import { RxCornerTopLeft } from "react-icons/rx";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { confirmAlert } from "react-confirm-alert";
import consentList from "./consentList";
import UserContext from "user/UserContext";
import { toast } from "sonner";
import log from "loglevel";
import { parseErrors } from "lib/errors/parse";
import { REGISTER_PAGE } from "auth/register/constants";

const ModalFrame = styled.div`
  // display: ${(props) => (props.$visible ? "flex" : "none")};
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgb(45, 49, 45, 0.5);
  z-index: 1010;
`;

const Modal = styled.div`
  box-sizing: border-box;
  position: relative;
  top: 80px;
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  align-items: center;
  border-radius: 20px;
  width: 350px;
  height: 450px;
  margin: 0 auto;
  background: #fafbfa;
  background: white;
  opacity: 1;
`;

const Title = styled.div`
  // height: 40px;
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 25px;
  font-weight: 500;
  color: #464646;
  // color: white;
  margin-top: 10px;
  // margin-left: 10px;
  margin-bottom: 20px;
  // background: black;
`;

const TotalItem = styled.div`
  width: 310px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  font-weight: bold;
  color: #363636;
`;

const Item = styled.div`
  width: 310px;
  height: 50px;
  border-radius: 4px;
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // background: LavenderBlush;
  // background: GainsBoro;
  background: #ebebec;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;
`;

const Topic = styled.div`
  margin-left: 10px;
`;

const Label = styled.label`
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // width: 100%;
  // padding-right: 20px;
  margin-left: 5px;
  // font-size: 15px;
  // background: red;
`;

const ShowDetail = styled.div`
  display: flex;  
  justify-content: flex-end;
  align-items: center;
  box-sizing: border-box;
  width: 60px;
  height: 35px;
  // margin-right: 15px;
  padding: 10px;
  cursor: pointer;
  // background: red;

  &:hover {
    background: lightgray;
  }
`;

const Spacer = styled.div`
  width: 30px;;
`;

const ButtonsContainer = styled.div`
  width: 310px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  // background: red;
`;

const StatusBar = styled.div`
  box-sizing: border-box;  
  width: 310px;
  margin-top: 12px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: flex-end;
  // background: red;
`;

const TextButton = styled.div`
  color: blue;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  &:hover {
    background: lightgray;
  }
`;

const ConsentModal = ({ submitting, onSubmit, onCancel }) => {
  const { modalActions } = useContext(ModalContext);
  const [checkedItems, setCheckedItems] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [consentItem, setConsentItem] = useState(null);
  const navigate = useNavigate();
  
  const handleSelectAll = e => {
    if (e.target.checked) {
      const newCheckedItems = [];
      consentList.forEach(item => newCheckedItems.push(item.id));
      setCheckedItems(newCheckedItems);
    } else {
      setCheckedItems([]);
    }
  };

  const handleSelect = (e, item) => {
    console.log('select', e);
    console.log(e.target.checked);
    console.log(item);
    if (e.target.checked) {
      setCheckedItems(prev => [...prev, item.id]);
    } else {
      setCheckedItems(checkedItems.filter(id => id !== item.id ));
    }
  };

  const handleShowDetail = (e, item) => {
    modalActions.setConsentVisible(false);
    setShowDetail(true);
    setConsentItem(item);
  };

  const handleConsent = async () => {
    if (submitting) return;

    const requiredItems = [0, 1, 2];
    const result = requiredItems.every(item => checkedItems.includes(item));
    if (!result) {
      toast.error('필수 항목은 반드시 체크해야 합니다.');
      return;
    }

    const allow_notice = checkedItems.includes(3);
    onSubmit(allow_notice);
  };

  const handleNoConsent = () => {
    const yes = window.confirm("동의하지 않으면 회원가입할 수 없습니다. 종료하시겠습니까?");
    if (yes) {
      navigate('/');
    }
  };

  const handleClose = () => {
    const yes = window.confirm('취소 하시겠습니까? 첫 화면으로 이동합니다.');
    if (yes) {
      onCancel();
    }
  };

  const onCloseShowDetail = () => {
    setShowDetail(false);
    modalActions.setConsentVisible(true);
  };

  return (
    <div className="ConsentModal">
      <ModalFrame>
        <Modal>
          <Title>Den05 이용약관</Title>
          <TotalItem>
            <Topic>
              <input 
                type="checkbox" 
                name="select-all" 
                onChange={handleSelectAll} 
                checked={checkedItems.length === consentList.length ? true : false}
              />
              <Label>전체 선택</Label>
            </Topic>
          </TotalItem>

          {consentList.map(item => (
            <Item key={item.id}>
              <Topic>
                <input 
                  type="checkbox" 
                  name={`select-${item.id}`} 
                  onChange={e => handleSelect(e, item)}
                  checked={checkedItems.includes(item.id) ? true : false}
                />
                <Label>{item.topic}</Label>
              </Topic>
              <ShowDetail onClick={e => handleShowDetail(e, item)}>
                <AiOutlineRight size="20px" />
              </ShowDetail>
            </Item>
          ))}
          <ButtonsContainer>
            <StyledButton color="pink" $fullWidth onClick={handleConsent} disabled={submitting}>
              {!submitting ? "동의" : "처리중..."}
            </StyledButton>
            <Spacer />
            <StyledButton $fullWidth onClick={handleNoConsent}>동의 안함</StyledButton>
          </ButtonsContainer>
          <StatusBar>
              <TextButton onClick={handleClose}>닫기</TextButton>
          </StatusBar>
          {/* {checkedItems.map(item => (
            <label key={item}>id: {item}</label>
          ))} */}
        </Modal>
    </ModalFrame>
    {showDetail && (
      <ConsentDetailModal consentItem={consentItem} onClose={onCloseShowDetail} />
    )}
    </div>
  );
};

export default ConsentModal;